import wlmMachine from './main.vue';

export default {
  install(Vue) {
    Vue.component(wlmMachine.name, wlmMachine);
  },
};
